import React, { Component } from "react";
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class ImportCVS extends Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
      formInvalid: false
    };

    this.resetData = this.resetData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  resetData() {
    this.setState({
      file: null,
      formInvalid: false
    });
  }

  handleChange(e) {
    const { files } = e.target;
    if (!files || files.length == 0) return;
    this.setState({ file: files[0] });
  }

  onCancel(e) {
    this.resetData();
    this.props.onCancel();
  }

  async onSubmit(e) {
    const { file } = this.state;

    const formInvalid = file == null;
    await this.setState({ formInvalid });
    if (formInvalid) return;

    this.props.onSubmit(file);
    this.resetData();
    this.props.onCancel();
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader>Carga Masiva</ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="2" md="3">
              Archivo:
            </Col>
            <Col>
              <div className="custom-file">
                <input
                  type="file"
                  className={`custom-file-input ${this.state.formInvalid ? "is-invalid" : ""}`}
                  id="validatedCustomFile"
                  accept=".xls,.xlsx,.csv"
                  onChange={this.handleChange}
                />
                <label className="custom-file-label" htmlFor="validatedCustomFile">
                  {this.state.file ? this.state.file.name : "Seleccione archivo"}
                </label>
                <div className="invalid-feedback">Elija un archivo a subir</div>
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onSubmit} disabled={this.props.disabled}>
            Subir
          </Button>
          <Button color="secondary" onClick={this.onCancel}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ImportCVS;



// WEBPACK FOOTER //
// ./src/components/CSV/ImportCSV/ImportCSV.js